import { Big } from 'big.js';

Big.DP = 40;
Big.NE = -40;
Big.PE = 40;

export default Big;
